import React from 'react';
import '../../App.css';

export default function Objetivo() {
    return <>
        <body className='objetivo'>
            <p className='texto'>
                A iniciativa surge como um meio de conectar rapidamente pacientes em necessidade e doadores adequados e dispon&iacute;veis. Almejamos evitar fatalidades por uma falha de log&iacute;stica que acreditamos poder ser resolvida! A falta de bancos de sangue veterin&aacute;rio traz s&eacute;rias dificuldades no processo de transfus&atilde;o de sangue entre animais de companhia, pois gera a necessidade de doadores sempre dispon&iacute;veis.
            </p>
            <p className='texto'>
                Os doadores precisam cumprir uma s&eacute;rie de requisitos e, muitas vezes, n&atilde;o &eacute; poss&iacute;vel encontrar um animal que se adeque a tempo. A constru&ccedil;&atilde;o pr&eacute;via do banco de dados apenas com animais aptos vem para acelerar esse contato.
            </p>

            <div className="row">
                <img class="time" src={"./Objetivo/Fabiola.jpeg"} />
                <div className="collumn">
                    <p className='participantes'>
                        Fab&iacute;ola Paes Leme
                    </p>
                    <p className='descricao'>
                        Possui gradua&ccedil;&atilde;o em Medicina Veterin&aacute;ria pela Universidade Jos&eacute; do Ros&aacute;rio Vellano (1996), mestrado em Medicina Veterin&aacute;ria pela Universidade Federal de Minas Gerais (2000) e doutorado em Ci&ecirc;ncia Animal pela Universidade Federal de Minas Gerais (2004) com sandu&iacute;che na LMU (Alemanha). Atualmente &eacute; orientadora plena do programa de p&oacute;s gradua&ccedil;&atilde;o em Ci&ecirc;ncia Animal e tutora no programa de resid&ecirc;ncia m&eacute;dica integrada da Universidade Federal de Minas Gerais, coordenadora geral do MULTILAB (LIPq- UFMG), coordenadora do programa de extens&atilde;o #CONECTALAB- educa&ccedil;&atilde;o continuada e do grupo de estudos em Patologia Cl&iacute;nica (GEPAC) da Universidade Federal de Minas Gerais, sub-coordenadora do laborat&oacute;rio de patologia cl&iacute;nica do Hospital Veterin&aacute;rio da UFMG e membro de v&aacute;rias comiss&otilde;es designadas pelas chefias. Presidente da Subcomiss&atilde;o de Patologia Cl&iacute;nica do Col&eacute;gio Brasileiro de Nefrologia e Urologia Veterin&aacute;rias (CBNUV). Tem experi&ecirc;ncia na &aacute;rea de Medicina Veterin&aacute;ria, com &ecirc;nfase em Patologia Cl&iacute;nica Veterin&aacute;ria, atuando principalmente nos seguintes temas: hematologia, bioqu&iacute;mica cl&iacute;nica, nefrologia, estresse oxidativo, perfil metab&oacute;lico, medicina regenerativa e micologia cl&iacute;nica veterin&aacute;ria.
                    </p>
                </div>
            </div>

            <div className="row">
                <img class="time" src={"./Objetivo/Fernanda.jpeg"} />
                <div className="collumn">
                    <p className='participantes'>
                        Fernanda Corr&ecirc;a
                    </p>
                    <p className='descricao'>
                        Idealizadora do Projeto, aluna do sexto per&iacute;odo em Medicina Veterin&aacute;ria na Universidade Federal de Minas Gerais (UFMG).
                    </p>
                </div>
            </div>

            <div className="row">
                <img class="time" src={"./Objetivo/Diogo.jpg"} />
                <div className="collumn">
                    <p className='participantes'>
                        Diogo Almeida
                    </p>
                    <p className='descricao'>
                        Co-fundador do projeto, estudante do sexto per&iacute;odo em Ci&ecirc;ncia da Computa&ccedil;&atilde;o e Economia na Rochester Institute of Technology em Nova Iorque.
                    </p>
                </div>
            </div>

            
            <div className="row">
                <img class="time" src={"./Objetivo/Vinicius.jpeg"} />
                <div className="collumn">
                    <p className='participantes'>
                        Vin&iacute;cius Amaral
                    </p>
                    <p className='descricao'>
                        Estudante de medicina veterin&aacute;ria, atualmente participo do n&uacute;cleo de marketing do Hemopets. Aluno do sexto per&iacute;odo em Medicina Veterin&aacute;ria na Universidade Federal de Minas Gerais (UFMG).
                    </p>
                </div>
            </div>

            <div className="row">
                <img class="time" src={"./Objetivo/Mariana.jpeg"} />
                <div className="collumn">
                    <p className='participantes'>
                        Mariana Guimarães
                    </p>
                    <p className='descricao'>
                        Respons&aacute;vel pela gest&atilde;o do projeto. Aluna do oitavo per&iacute;odo em Medicina Veterin&aacute;ria na Universidade Potiguar de Natal (Unp- Natal RN)
                    </p>
                </div>
            </div>

            <div className="row">
                <img class="time" src={"./Objetivo/Juliana.jpg"} />
                <div className="collumn">
                    <p className='participantes'>
                        Juliana Alves
                    </p>
                    <p className='descricao'>
                        Integrante da equipe de Marketing do projeto. Aluna do sexto per&iacute;odo em Medicina Veterin&aacute;ria na Universidade Federal de Minas Gerais (UFMG).
                    </p>
                </div>
            </div>

            <div className="row">
                <img class="time" src={"./Objetivo/Pimenta.jpg"} />
                <div className="collumn">
                    <p className='participantes'>
                        Ana Clara Pimenta
                    </p>
                    <p className='descricao'>
                        Integrante da equipe de extens&atilde;o do projeto, respons&aacute;vel pela articula&ccedil;&atilde;o entre a sociedade e o projeto. Aluna do oitavo per&iacute;odo de Medicina Veterin&aacute;ria na Universidade Federal de Minas Gerais.
                    </p>
                </div>
            </div>

            <div className="row">
                <img class="time" src={"./Objetivo/Adriane.jpeg"} />
                <div className="collumn">
                    <p className='participantes'>
                        Adriane Espeschit
                    </p>
                    <p className='descricao'>
                        Integrante do grupo de extens&atilde;o do projeto. Estudante do s&eacute;timo per&iacute;odo de Medicina Veterin&aacute;ria na Universidade Federal de Minas Gerais.
                    </p>
                </div>
            </div>

            <div className="row">
                <img class="time" src={"./Objetivo/Rhayssa.jpeg"} />
                <div className="collumn">
                    <p className='participantes'>
                        Rhayssa de Souza
                    </p>
                    <p className='descricao'>
                        Integrante da equipe de Marketing, que tem o objetivo de divulgar o projeto em diversas plataformas digitais. Aluna do quinto per&iacute;odo em Medicina Veterin&aacute;ria na Universidade Federal de Minas Gerais (UFMG).
                    </p>
                </div>
            </div>


        </body>
    </>;
}